import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Account } from '../../../../models/ui/account.model';

@Component({
    selector: 'lex-create-account-dialog',
    templateUrl: './create-account-dialog.component.html',
    styleUrls: ['./create-account-dialog.component.scss'],
    standalone: false
})
export class CreateAccountDialogComponent {

	public newAccountForm: UntypedFormGroup;
	private newAccount = new Account();

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<CreateAccountDialogComponent>) {
		this.newAccountForm = this.formBuilder.group({
			accountName: ['', [Validators.required, Validators.maxLength(256)]],
			isHibernated: new UntypedFormControl(false)
		});
	}

	public updateAccountName(isHibernated: boolean): void {
		const currentAccountName = this.newAccountForm.controls['accountName'].value as string;
		if (isHibernated && !currentAccountName.toLowerCase().includes('-hibernated')) {
			this.newAccountForm.controls['accountName'].setValue(`${currentAccountName}-Hibernated`);
			this.newAccountForm.controls['accountName'].markAsDirty();
		} else if (!isHibernated && currentAccountName.toLowerCase().includes('-hibernated')) {
			this.newAccountForm.controls['accountName'].setValue(currentAccountName.replace(/-hibernated/i, ''));
			this.newAccountForm.controls['accountName'].markAsDirty();
		}
	}

	public addNewAccount(): void {
		this.newAccount.accountName = this.newAccountForm.controls['accountName'].value;
		this.newAccount.isHibernated = this.newAccountForm.controls['isHibernated'].value;
		this.dialogRef.close(this.newAccount);
	}

}
